import { Component, OnInit, Inject } from '@angular/core';

import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn, FormBuilder, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyRadioChange as MatRadioChange } from '@angular/material/legacy-radio';
import { IApplicationTaxRequest, SignerInput } from '@ebb-v2/ebb-integration';

export interface ITaxRequest {
  isMarried: boolean;
  name: string;
  spouseName: string;
}

@Component({
  selector: 'ebb-portal-dialog-taxrequest',
  templateUrl: './dialog-taxrequestform.component.html'
})
export class DialogtaxrequestformComponent implements OnInit {
  public formtaxrequest: FormGroup;
  public currentDate: Date = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate()
  );
public submitted = false; // <— add this
  public innerHeight;
  public yearquestion = '';
  public readOnlySsnLast4 = false;
  public readOnlySpouseSsnLast4 = false;
  constructor(
    public dialogRef: MatDialogRef<DialogtaxrequestformComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IApplicationTaxRequest,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.innerHeight = window.innerHeight;
    this.initializeForm();
  }

  private initializeForm(): void {
    const d = new Date();
    let y = d.getFullYear() - 1;
    const m = d.getMonth() +1;
    if(this.data.taxYear === null || this.data.taxYear === undefined){
      this.data.taxYear ='';
    }
if(this.data.taxYear.length >0){
y = Number.parseInt(this.data.taxYear);
}else{
  y = d.getFullYear() - 2;
}
  
       
 

    this.yearquestion = "What was this person's filing status in " + y + '?';

    this.formtaxrequest = this.fb.group({
      nameFirst: ['', Validators.required],
      nameInitial: [''],
      nameLast: ['', Validators.required],
      nameSSN: [''],
      nameFirstSpouse: ['', Validators.required],
      nameInitialSpouse: [''],
      nameLastSpouse: ['', Validators.required],
      nameSSNSpouse: [''], // Required conditionally
      householdStatus: ['', Validators.required],
      email: ['', [ // Required conditionally
        Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
        Validators.maxLength(100)
      ]]
    }, { validators: [this.ssnNotSameValidator()] });

    this.formtaxrequest.setValidators(this.ssnNotSameValidator());
this.formtaxrequest.updateValueAndValidity({ emitEvent: false });
     this.formtaxrequest.get('nameSSN')?.valueChanges.subscribe(() => {
  this.formtaxrequest.updateValueAndValidity({ emitEvent: false });
});
this.formtaxrequest.get('nameSSNSpouse')?.valueChanges.subscribe(() => {
  this.formtaxrequest.updateValueAndValidity({ emitEvent: false });
});
    this.applyConditionalValidators();
  }
 


private ssnNotSameValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const borrower = group.get('nameSSN');
    const spouse   = group.get('nameSSNSpouse');
    if (!borrower || !spouse) return null;

    // Ignore when controls are disabled (e.g., not married)
    if (borrower.disabled || spouse.disabled) {
      // clear any stale errors
      const e1 = borrower.errors; if (e1?.ssnSamePair) { const { ssnSamePair, ...rest } = e1; borrower.setErrors(Object.keys(rest).length ? rest : null); }
      const e2 = spouse.errors;   if (e2?.ssnSame)     { const { ssnSame, ...rest }     = e2; spouse.setErrors(Object.keys(rest).length ? rest : null); }
      return null;
    }

    const a = String(borrower.value ?? '').replace(/\D/g, '');
    const b = String(spouse.value ?? '').replace(/\D/g, '');

    // Only enforce when both full 9 digits present (avoid false positives on partials/last-4)
    const same = a.length === 9 && b.length === 9 && a === b;

    if (same) {
      // Mark BOTH invalid so the red state shows under either field
      borrower.setErrors({ ...(borrower.errors || {}), ssnSamePair: true });
      spouse.setErrors({ ...(spouse.errors   || {}), ssnSame: true });
      return { ssnSame: true };
    } else {
      // scrub only our keys, leave others (e.g., 'required') intact
      const e1 = borrower.errors;
      if (e1?.ssnSamePair) { const { ssnSamePair, ...rest } = e1; borrower.setErrors(Object.keys(rest).length ? rest : null); }
      const e2 = spouse.errors;
      if (e2?.ssnSame)     { const { ssnSame, ...rest }     = e2; spouse.setErrors(Object.keys(rest).length ? rest : null); }
      return null;
    }
  };
}
  public applyConditionalValidators(): void {
    const nameSSNControl = this.formtaxrequest.get('nameSSN');
    const nameSSNSpouseControl = this.formtaxrequest.get('nameSSNSpouse');
    const emailControl = this.formtaxrequest.get('email');
  
    // SSN
    if (this.data.isBorrowerAssisted) {
      nameSSNControl.setValidators([Validators.required]);
    } else {
      nameSSNControl.clearValidators();
    }
  
    // Spouse SSN
    if (this.data.isBorrowerAssisted && this.data.isMarried) {
      nameSSNSpouseControl.setValidators([Validators.required]);
    } else {
      nameSSNSpouseControl.clearValidators();
    }
  
    // Email
    if (this.data.isBorrowerAssisted) {
      emailControl.setValidators([
        Validators.required,
        Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
        Validators.maxLength(100)
      ]);
    } else {
      emailControl.setValidators([
        Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
        Validators.maxLength(100)
      ]);
    }
  
    nameSSNControl?.updateValueAndValidity({ emitEvent: false });
    nameSSNSpouseControl?.updateValueAndValidity({ emitEvent: false });
    emailControl?.updateValueAndValidity({ emitEvent: false });

    // also re-run the form-level validator
    this.formtaxrequest.updateValueAndValidity({ emitEvent: false });
  }
  public onCheckControlValidators(controlName: string): boolean {
    const retVal = (this.formtaxrequest.get(controlName).errors 
                      && (this.formtaxrequest.get(controlName).dirty || this.formtaxrequest.get(controlName).touched));
    return retVal;
  }
  public onChangeSsn(event,controlName: string): void { 
    const ssnValue = this.formtaxrequest.get(controlName).value as string;
    if(ssnValue && ssnValue.startsWith('00000') && ssnValue.length < 9){
      this.formtaxrequest.get(controlName).setValue('');
      if(controlName === 'nameSSN'){
        this.readOnlySsnLast4 = false;}
        if(controlName === 'nameSSNSpouse'){
          this.readOnlySpouseSsnLast4 = false;}
    
    }
  }
  public onChangeEvent(event: MatRadioChange): void {
    this.data.isMarried = this.setIsMarried(event.value);

    if (this.data.isMarried) {
      this.formtaxrequest.get('nameFirstSpouse').enable();
      this.formtaxrequest.get('nameInitialSpouse').enable();
      this.formtaxrequest.get('nameLastSpouse').enable();
      
    } 
    else {
      this.formtaxrequest.get('nameFirstSpouse').setValue('');
      this.formtaxrequest.get('nameFirstSpouse').disable();
      this.formtaxrequest.get('nameInitialSpouse').setValue('');
      this.formtaxrequest.get('nameInitialSpouse').disable();
      this.formtaxrequest.get('nameLastSpouse').setValue('');
      this.formtaxrequest.get('nameLastSpouse').disable();
    }

    if(this.data.isBorrowerAssisted){
      if (this.data.isMarried) {
        this.formtaxrequest.get('nameSSNSpouse').enable();
       
      }else{
        this.formtaxrequest.get('nameSSNSpouse').setValue('');
        this.formtaxrequest.get('nameSSNSpouse').disable();
      }
      
    }

    // IMPORTANT: re-apply validators when status changes
    this.applyConditionalValidators();
  }

  public onSave(): void {

    this.submitted = true;                // <— show mat-errors immediately
    this.formtaxrequest.markAllAsTouched(); // <— mark all for display
    this.formtaxrequest.updateValueAndValidity();

    if (this.formtaxrequest.invalid) {
      return; // block submit; errors now visible
    }
    const signer1: SignerInput = {} as SignerInput;
    signer1.signerNameFirst = (this.formtaxrequest.get('nameFirst').value).trim();
    signer1.signerNameMiddle = (this.formtaxrequest.get('nameInitial').value).trim();
    signer1.signerNameLast = (this.formtaxrequest.get('nameLast').value).trim();
    signer1.clientId = '';
    signer1.recipientId = '';
    signer1.viewUrl = '';
    if(this.data.isBorrowerAssisted){
      signer1.signerSSN = this.formtaxrequest.get('nameSSN').value;
    }
    this.data.signer1 = signer1;
    const signer2: SignerInput = {} as SignerInput;
    signer2.signerNameFirst = (this.formtaxrequest.get('nameFirstSpouse').value).trim();
    signer2.signerNameMiddle = (this.formtaxrequest.get('nameInitialSpouse').value).trim();
    signer2.signerNameLast = (this.formtaxrequest.get('nameLastSpouse').value).trim();
    signer2.clientId = '';
    signer2.recipientId = '';
    signer2.viewUrl = '';
    this.data.signer2 = signer2;
    this.data.isMarried = this.setIsMarried(this.formtaxrequest.get('householdStatus').value);
    if(this.data.isBorrowerAssisted && this.data.isMarried){
      signer1.signerSSN = this.formtaxrequest.get('nameSSN').value;
    }
    if(this.data.isBorrowerAssisted){
      this.data.email = this.formtaxrequest.get('email').value;
      if(this.data.isMarried) {
        signer2.signerSSN = this.formtaxrequest.get('nameSSNSpouse').value;
      } 
    }
    let closeForm: boolean = true;

    if (this.data.isMarried) {
      if (signer1.signerNameFirst.length === 0) {
        this.formtaxrequest.get('nameFirst').setValue('');
        closeForm = false;
      }
      if (signer1.signerNameLast.length === 0) {
        this.formtaxrequest.get('nameLast').setValue('');
        closeForm = false;
      }
      if (signer2.signerNameFirst.length === 0) {
        this.formtaxrequest.get('nameFirstSpouse').setValue('');
        closeForm = false;
      }
      if (signer2.signerNameLast.length === 0) {
        this.formtaxrequest.get('nameLastSpouse').setValue('');
        closeForm = false;
      }
    } else {
      if (signer1.signerNameFirst.length === 0) {
        this.formtaxrequest.get('nameFirst').setValue('');
        closeForm = false;
      }
      if (signer1.signerNameLast.length === 0) {
        this.formtaxrequest.get('nameLast').setValue('');
        closeForm = false;
      }
    }

    if (closeForm === true) {
        this.dialogRef.close(this.data);
    }
  }

  public onClickCancel(): void {
    this.dialogRef.close();
  }

  private setIsMarried(input: string) : boolean {
    if(input === 'Married Filing Jointly')  {
      return true;
    }

    return false;
  }
}
